import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function SalesNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentNotification, setCurrentNotification] = useState({
    name: '',
    location: ''
  });
  const customers = [{
    name: 'María',
    location: 'Ciudad de México'
  }, {
    name: 'Carmen',
    location: 'Madrid'
  }, {
    name: 'Ana',
    location: 'Buenos Aires'
  }, {
    name: 'Sofía',
    location: 'Bogotá'
  }, {
    name: 'Isabella',
    location: 'Lima'
  }, {
    name: 'Valentina',
    location: 'Santiago'
  }, {
    name: 'Camila',
    location: 'Monterrey'
  }, {
    name: 'Lucía',
    location: 'Barcelona'
  }, {
    name: 'Martina',
    location: 'Guadalajara'
  }, {
    name: 'Elena',
    location: 'Medellín'
  }, {
    name: 'Paula',
    location: 'Quito'
  }, {
    name: 'Andrea',
    location: 'San José'
  }, {
    name: 'Daniela',
    location: 'Caracas'
  }, {
    name: 'Gabriela',
    location: 'La Paz'
  }, {
    name: 'Fernanda',
    location: 'Puebla'
  }];
  useEffect(() => {
    const showNotification = () => {
      // Randomize customer
      const randomCustomer = customers[Math.floor(Math.random() * customers.length)];
      setCurrentNotification(randomCustomer);
      setIsVisible(true);
      // Hide after 3 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 3000);
    };
    // Initial delay before first notification
    const initialDelay = setTimeout(() => {
      showNotification();
      // Repeat every 10 seconds (3s visible + 7s hidden)
      const interval = setInterval(showNotification, 10000);
      return () => clearInterval(interval);
    }, 2000);
    return () => clearTimeout(initialDelay);
  }, []);
  return <AnimatePresence data-id="element-226">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 100,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        type: 'spring',
        stiffness: 500,
        damping: 30
      }
    }} exit={{
      opacity: 0,
      y: 20,
      transition: {
        duration: 0.3
      }
    }} className="fixed bottom-6 left-4 right-4 z-50 md:hidden" data-id="element-227">
          <div className="mx-auto max-w-sm bg-white/90 backdrop-blur-xl rounded-2xl shadow-[0_10px_40px_rgba(0,0,0,0.15)] border border-gray-200/50 p-3" data-id="element-228">
            <div className="flex items-center gap-3" data-id="element-229">
              {/* Product Image */}
              <div className="flex-shrink-0" data-id="element-230">
                <img src="https://cdn.magicpatterns.com/uploads/q4Vp5WLEeVtKRxmNFZiqpW/PORTADA_-_EBOOK.png" alt="Quincena Milagrosa" className="w-12 h-12 rounded-lg object-cover shadow-sm" data-id="element-231" />
              </div>

              {/* Notification Content */}
              <div className="flex-1 min-w-0" data-id="element-232">
                <div className="flex items-center gap-1.5 mb-0.5" data-id="element-233">
                  <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-234" />
                  <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide" data-id="element-235">
                    Nueva venta
                  </p>
                </div>
                <p className="text-sm font-medium text-gray-900 leading-tight" data-id="element-236">
                  <span className="font-semibold" data-id="element-237">
                    {currentNotification.name}
                  </span>{' '}
                  de{' '}
                  <span className="text-gray-700" data-id="element-238">
                    {currentNotification.location}
                  </span>
                </p>
                <p className="text-xs text-gray-600 mt-0.5" data-id="element-239">
                  Compró <span className="font-medium" data-id="element-240">Quincena Milagrosa</span>{' '}
                  por{' '}
                  <span className="font-semibold text-green-600" data-id="element-241">$7.97</span>
                </p>
              </div>

              {/* Close indicator (optional) */}
              <div className="flex-shrink-0" data-id="element-242">
                <div className="w-1 h-8 bg-gradient-to-b from-amber-400 to-orange-500 rounded-full" data-id="element-243" />
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}